import { gql } from '@apollo/client';

export const common = gql`
  query {
    isWebview @client
    isAndroid @client
    isMobile @client
    abRandValue @client
    source @client
    user @client
  }
`;

export const getLocalities = gql`
  query GetLocality($id: Int!) {
    getLocalitiesByCityId(input: $id) {
      id
      name
    }
  }
`;

export const getTopCities = gql`
  query {
    topcities {
      id
      name
    }
  }
`;

export const citySuggest = gql`
  query GetCities($payload: CitySuggestInput!) {
    citysuggest(input: $payload) {
      id
      name
    }
  }
`;

export const localitySuggest = gql`
  query GetLocalities($payload: LocalitySuggestInput!) {
    localitySuggest(input: $payload) {
      id
      name
    }
  }
`;

export const getTokens = TOKEN_KEY => gql`
  query getTokens @client {
    tokens @client {
      ${TOKEN_KEY} {
        action
        type
      }
    }
  }
`;

export const emailList = gql`
  query EmailList {
    isMobile @client
    getemaillist {
      emailList {
        email
      }
    }
  }
`;

export const getCityByPincode = gql`
  query GetCityByPin($id: ID!) {
    getCityByPin(id: $id) {
      id
      name
    }
  }
`;
